import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { CarsCustomerService } from '@customers/services/cars.customer.service';
import { RequestsCustomerService } from '@customers/services/requests.customer.service';
import { AuthService } from '@reusable/services/auth/auth.service';
import { ContentService } from '@reusable/services/common/content.service';
import * as globals from '@reusable/services/globals';
import { handleReadableMessage } from '@reusable/services/globals';
import { S3Uploader } from '@reusable/services/helpers/uploader.service';
import { ToastrService } from 'ngx-toastr';
import { take } from 'rxjs/operators';
import { ValidateVinService, vinValidator } from '@reusable/services/validate-vin';

@Component({
  selector: 'app-my-cars-form',
  standalone: false,
  templateUrl: './my-cars-form.component.html',
  styleUrls: ['./my-cars-form.component.scss']

})
export class MyCarsFormComponent implements OnInit {
  id: any;
  adding: boolean;
  carForm = this.fb.group({
    alias: ['Work car'],
    manufacture: [null, Validators.required],
    carName: [null, Validators.required],
    modelYear: [null, Validators.required],
    vinNumber: [null, [Validators.required, vinValidator(this.vvs)]],
    modelId: []
  });

  yearItem = [];
  cities = [];
  cars = [];
  noCars = true;
  ngloading = false;
  queryOptions = {
    sortBy: 'order',
    records: null,
    pageNumber: 1
  };
  manufactures = [];
  manufactureList = [];
  selectedModel = null;
  modelsList = [];
  carFormErrors = {
    manufacture: '',
    carName: '',
    modelYear: ''
  };
  carValidationMessages = {
    manufacture: 'This Field Required',
    carName: 'This Field Required',
    modelYear: 'This Field Required'
  };
  toastMessage = '';
  toastType = '';
  show: boolean;

  constructor(
    private auth: AuthService,
    public cs: ContentService,
    private fb: UntypedFormBuilder,
    private router: Router,
    private requestCusServ: RequestsCustomerService,
    private carcs: CarsCustomerService,
    private s3Uploader: S3Uploader,
    private toastr: ToastrService,
    private route: Router,
    private activeRoute: ActivatedRoute,
    private title: Title,
    private vvs: ValidateVinService
  ) {}

  ngOnInit() {
    this.title.setTitle('سبيرو - اضافة سيارة');
    this.activeRoute.params.subscribe((params: any) => {
      if ('id' in params) {
        this.getMyCarData(params.id);
        this.id = params.id;
      }
    });
    this.yearItem = globals.generateYear();
    this.getCoreCars();
    this.getCities();
    this.gitMyCarsList();
    this.carForm.valueChanges.subscribe(value => this.carOnValueChanged(value));
  }

  getCities() {
    this.cs.getCities().subscribe((cities: any) => {
      if (cities.case === 1) {
        this.cities = cities.cities.map(city => ({ id: city._id, label: city.nameArabic, area: city.areaId?.nameArabic }));
      }
    });
  }

  gitMyCarsList() {
    this.noCars = false;
    if (this.auth.isLoggedIn()) {
      this.carcs.listCars('-createdAt', 30, 1).subscribe(
        (data:any) => {
          if (data.case === 1) {
            this.cars = data.cars.map(car => ({
              id: car._id,
              label: `${car.manufactureId.nameArabic}, ${car.modelId.nameArabic}, ${car.modelYear}`,
              premiumNewPrice: car.manufactureId.premiumNewPrice,
              premiumUsedPrice: car.manufactureId.premiumUsedPrice
            }));
          } else {
            this.noCars = true;
          }
        },
        () => {}
      );
    }
  }

  getCoreCars() {
    this.cs
      .getManufactures(this.queryOptions.sortBy, this.queryOptions.records, this.queryOptions.pageNumber, { isDeleted: false })
      .subscribe((data: any) => {
        if (data.case === 1) {
          this.manufactures = data.manufs;
          this.manufactureList = data.manufs.map(man => ({
            id: man._id,
            label: man.nameArabic,
            models: man.modelsIds
          }));
        }
      });
  }

  toggleIt() {
    this.show = !this.show;
  }

  getModelsList(e) {
    this.selectedModel = [];
    if (!e) {
      this.modelsList = [];
      return false;
    }
    this.ngloading = true;
    this.cs.getModels(e.id).subscribe((res: any) => {
      this.ngloading = false;
      this.modelsList = [{ label: 'جاري جلب قائمة الموديلات', disabled: true }];
      if (res.case === 1) {
        this.modelsList = res.models.map(model => ({
          id: model._id,
          label: model.nameArabic
        }));
      } else {
        this.modelsList = [{ label: 'اختر شركة مصنعة أخرى', disabled: true }];
      }
    });
  }

  carOnValueChanged(value) {
    const form = this.carForm;
    for (const field in this.carFormErrors) {
      if (this.carFormErrors.hasOwnProperty(field)) {
        this.carFormErrors[field] = '';
        const control = form.get(field);
        if (control?.dirty && !control.valid) {
          const messages = this.carValidationMessages[field];
          for (const key in control.errors) {
            if (control.errors.hasOwnProperty(key)) {
              this.carFormErrors[field] += `${messages[key]} `;
            }
          }
        }
      }
    }
  }

  submitCarForm() {
    if (this.carForm.valid) {
      this.adding = true;
      const body = {
        car: {
          alias: this.carForm.value.alias,
          vinNumber: this.carForm.value.vinNumber,
          modelId: this.carForm.value.carName.id,
          manufactureId: this.carForm.value.manufacture.id,
          modelYear: this.carForm.value.modelYear
        }
      };

      let method = this.carcs.addCar(body);
      if (this.id) {
        body.car.modelId = this.carForm.value.carName.id || this.carForm.value.carName;
        body.car.manufactureId = this.carForm.value.manufacture.id || this.carForm.value.manufacture;
        method = this.carcs.updateCar(this.id, body);
      }
      method.pipe(take(1)).subscribe(
        (data:any) => {
          handleReadableMessage(data);
          switch (data.case) {
            case 0:
              this.adding = false;
              this.toastr.info('لا يمكنك تعديل السيارة بعد إنشاء طلب تسعير لها');
              break;
            case 1:
              this.adding = false;
              this.toastr.success(`تم ${this.id ? 'تعديل' : 'إضافة'} السيارة بنجاح`);
              this.route.navigate(['/home/my-cars']);
              break;
            case 2:
              this.adding = false;
              this.toastr.info('لا يمكن اضافة المزيد من السيارات');
              break;
          }
        },
        err => {
          this.adding = false;
          this.toastr.error(err);
        }
      );
    } else {
      this.validateAllFormFields(this.carForm);
    }
  }

  getMyCarData(id) {
    this.carcs
      .viewCar(id)
      .pipe(take(1))
      .subscribe((data: any) => {
        if (data.case === 1) {
          this.getModelsList({
            id: data.car.manufactureId._id
          });
          this.carForm.get('alias').setValue(data.car.alias || 'work car');
          this.carForm.get('manufacture').setValue(data.car.manufactureId._id);
          this.carForm.get('carName').setValue(data.car.modelId._id || '');
          this.carForm.get('modelYear').setValue(data.car.modelYear || '');
          this.carForm.get('vinNumber').setValue(data.car.vinNumber || '');
          this.carForm.get('modelId').setValue(data.car.modelId._id || '');
          const manufactureName = data.car.manufactureId?.nameArabic ? data.car.manufactureId.nameArabic : '';
          const modelName = data.car.modelId?.nameArabic ? data.car.modelId.nameArabic : '';
          this.title.setTitle(`سبيرو - تعديل السيارة ${manufactureName} ${modelName} ${data.car.modelYear}`);
        }
      });
  }

  validateAllFormFields(formGroup: UntypedFormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof UntypedFormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof UntypedFormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }

  displayFieldCss(field: string) {
    return {
      'ng-touched': this.isFieldValid(field),
      'ng-invalid': this.isFieldValid(field)
    };
  }

  isFieldValid(field: string) {
    return !this.carForm.get(field).valid && this.carForm.get(field).touched;
  }
}